module.exports = __webpack_public_path__ + "img/20200515_163509.62b4142e.jpg";